﻿(function ($, d) {
    $(document).ready(function () {
        $('[data-password-validator]').each(function (i, n) {
            var $this = $(this);
            var $controlToValidate = $($this.data('pv-control'));
            var invalidClass = $this.data('pv-invalid');
            var validClass = $this.data('pv-valid');
            $controlToValidate.on('keyup', function () {
                var isValid = true;
                $this.find('[data-pv-rule]').each(function (i, n) {
                    var rule = new RegExp($(n).data('pv-rule'));
                    $(n).removeClass('is-undefined is-invalid is-valid');
                    if (rule.test($controlToValidate.val())) {
                        $(n).addClass('is-valid');
                    } else {
                        isValid = false;
                        $(n).addClass('is-invalid');
                    }
                });

                if (!isValid) {
                    if (validClass.length > 0) {
                        $controlToValidate.removeClass(validClass);
                    }
                    if (invalidClass.length > 0) {
                        $controlToValidate.addClass(invalidClass);
                    }
                } else {
                    if (invalidClass.length > 0) {
                        $controlToValidate.removeClass(invalidClass);
                    }
                    if (validClass.length > 0) {
                        $controlToValidate.addClass(validClass);
                    }
                }
            });
        });
    });
})(jQuery, document);
